import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import './LanguageSwitcher.css';

const LANGUAGE_FLAGS = {
  de: "🇩🇪",
  en: "🇬🇧",
  tr: "🇹🇷",
  ar: "🇸🇦",
  pl: "🇵🇱",
  pt: "🇧🇷",
  fr: "🇫🇷",
  it: "🇮🇹",
  uk: "🇺🇦",
  es: "🇪🇸"
};

const LANGUAGE_NAMES = {
  de: "Deutsch",
  en: "English",
  tr: "Türkçe",
  ar: "العربية",
  pl: "Polski",
  pt: "Português",
  fr: "Français",
  it: "Italiano",
  uk: "Українська",
  es: "Español"
};

export const LanguageSwitcher = ({ variant = 'dropdown' }) => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  
  const currentLang = i18n.language?.split('-')[0] || 'de';
  
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setIsOpen(false);
  };
  
  // Inline flag buttons (for Home page)
  if (variant === 'flags') {
    return (
      <div className="language-flags-row">
        {Object.entries(LANGUAGE_FLAGS).map(([code, flag]) => (
          <button
            key={code}
            className={`language-flag-btn ${currentLang === code ? 'active' : ''}`}
            onClick={() => changeLanguage(code)}
            title={LANGUAGE_NAMES[code]}
            data-testid={`lang-switch-${code}`}
          >
            <span className="flag">{flag}</span>
          </button>
        ))}
      </div>
    );
  }
  
  // Dropdown (for Navbar)
  return (
    <div className="language-switcher">
      <button 
        className="language-switcher-trigger"
        onClick={() => setIsOpen(!isOpen)}
        data-testid="language-switcher"
      >
        <span className="current-flag">{LANGUAGE_FLAGS[currentLang]}</span>
        <Globe size={16} />
      </button>
      
      {isOpen && (
        <div className="language-dropdown">
          {Object.entries(LANGUAGE_FLAGS).map(([code, flag]) => (
            <button
              key={code}
              className={`language-option ${currentLang === code ? 'active' : ''}`}
              onClick={() => changeLanguage(code)}
              data-testid={`lang-option-${code}`}
            >
              <span className="flag">{flag}</span>
              <span className="name">{LANGUAGE_NAMES[code]}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
